@if (visible()) {
  <div class="authorization-progress">
    <nx-progressbar [value]="stepValue()" [max]="stepCount" ariaLabel="Authorization check in progress" />
    <p>{{ stepLabel() | transloco }}</p>
  </div>
}
